export const initialTransferLogTable = {
    items: [],
    totalElements: 0,
    page: 0,
    size: 10,
    serverTime: null,
    loading: false,
    filters: {
        fileName: "",
        proprietorSearch: "",
        logLevel: "",
        actionTaken: "",
        device: "",
        actionName: "",
        usersEncrypted: "",
        interlocutorSearch: "",
    },
    newEntriesCount: 0,
};
